import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import css from "../style.module.css"
export default function DeleteConfirmUserComponent({ handleDelete, user, onClose, isDeleting }) {

    return (
        <div
            className={css.adminLayout}

            role="dialog"
            aria-modal="true"
            aria-labelledby="delete-title"
            aria-describedby="delete-description"
        >
            <motion.div
                className={css.formContainer}
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.2 }}
                style={{ width: '320px', maxWidth: '90%' }}
            >
                <button className={`btn ${css.closeButton}`} onClick={() => onClose()}>
                    ×
                </button>
                <div className="text-center">
                    <i className="fa-solid fa-exclamation-triangle fa-2x text-warning mb-2" aria-hidden="true"></i>
                    <h2 id="delete-title" className="text-danger">
                        Confirm Delete
                    </h2>
                    <p id="delete-description">
                        Are you sure you want to delete <strong>{user.name}</strong> ({user.email})?
                    </p>
                </div>
                <div className="d-flex justify-content-center mt-4 gap-3">
                    <button
                        className="btn btn-secondary"
                        onClick={onClose}
                        type="button"
                    >
                        Cancel
                    </button>
                    <button
                        className="btn btn-danger"
                        onClick={() => { handleDelete(user);  }}
                        type="button"
                    >
                        Delete
                        {isDeleting ? (
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        ) : ""}
                    </button>
                </div>
            </motion.div>
        </div>
    );
}